import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Container, TextField, Button, Typography, Link, Stack, Alert } from "@mui/material";
import AuthApi from "../api/AuthApi";

const card = { p: { xs: 3, sm: 4 }, borderRadius: "var(--radius-lg)", bgcolor: "var(--surface)", border: "1px solid var(--border)", boxShadow: "var(--shadow-sm)" } as const;

/** Request a password-reset link. Always shows the same confirmation —
 *  mirrors the API's no-enumeration response. */
export default function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try { await AuthApi.passwordResetRequest(email); } catch { /* same message either way */ }
    setSent(true);
    setBusy(false);
  };

  return (
    <Container maxWidth="xs" sx={{ py: { xs: 6, sm: 10 } }}>
      <Box sx={card}>
        <Typography variant="h2" sx={{ fontSize: "1.4rem", mb: 1 }}>{t("auth.forgotTitle")}</Typography>
        <Typography sx={{ color: "text.secondary", mb: 2.5 }}>{t("auth.forgotBody")}</Typography>
        {sent ? (
          <Alert severity="success">{t("auth.forgotSent")}</Alert>
        ) : (
          <Stack spacing={2} component="form" onSubmit={(e) => { e.preventDefault(); submit(); }}>
            <TextField label={t("auth.email")} type="email" value={email}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)} autoFocus fullWidth required />
            <Button type="submit" variant="contained" size="large" disabled={busy || !email}>
              {busy ? t("funnel.submitting") : t("auth.forgotSubmit")}
            </Button>
          </Stack>
        )}
        <Typography sx={{ mt: 2, fontSize: ".9rem", color: "text.secondary" }}>
          <Link component={RouterLink} to="/inloggen">{t("auth.backToLogin")}</Link>
        </Typography>
      </Box>
    </Container>
  );
}
